import { makeStyles, Tooltip as MuiTooltip } from '@material-ui/core'
import React, { useRef, useState } from 'react'

const useStyles = () =>
  makeStyles({
    tooltipPopper: {
      opacity: 1
    },
    tooltipPopperArrow: {
      color: 'var(--bg-color-31)'
    },
    tooltipPopperArrowDark: {
      color: 'var(--bg-color-17)'
    },
    tooltipPopperArrowLight: {
      color: 'white'
    },
    tooltip: {
      opacity: 1,
      backgroundColor: 'var(--bg-color-31)',
      color: 'var(--text-color-7)'
    },
    tooltipDark: {
      backgroundColor: 'var(--bg-color-17)',
      color: 'var(--text-color-1)'
    },
    tooltipLight: {
      backgroundColor: 'white',
      color: 'black',
      boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.2)',
      padding: 20,
      whiteSpace: 'break-spaces',
      fontWeight: 400,
      maxWidth: 500
    }
  })()

const Tooltip = ({
  open = undefined,
  children,
  value,
  placement = 'right',
  disableTooltip = false,
  arrow,
  variant = 'dark',
  delay,
  wrapperClassName = '',
  containerClassName = '',
  tooltipContentClassName = '',
  arrowClassName = '',
  popperProps = {},
  interactive = false,
  onClick = () => {}
}) => {
  const classes = useStyles()
  const anchorRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = event => {
    const tooltip = event.relatedTarget?.closest?.('[role="tooltip"]')
    // MUI's blur timer must not close content that is receiving focus.
    // Let the original blur event reach the child and its ancestors normally.
    if (interactive && event.type === 'blur' && tooltip?.id === anchorRef.current?.getAttribute('aria-describedby')) {
      return
    }
    setIsOpen(false)
  }

  return (
    <MuiTooltip
      open={open === undefined ? isOpen : open}
      onOpen={() => setIsOpen(true)}
      onClose={handleClose}
      onClick={onClick}
      title={value}
      arrow={arrow}
      placement={placement}
      interactive={interactive}
      classes={{
        popper: classes.tooltipPopper,
        tooltip: [
          classes.tooltip,
          tooltipContentClassName,
          variant === 'dark' ? classes.tooltipDark : classes.tooltipLight
        ].join(' '),
        arrow: [
          classes.tooltipPopperArrow,
          arrowClassName,
          variant === 'dark' ? classes.tooltipPopperArrowDark : classes.tooltipPopperArrowLight
        ].join(' ')
      }}
      enterDelay={delay}
      disableHoverListener={disableTooltip}
      className={containerClassName}
      PopperProps={popperProps}
    >
      <div ref={anchorRef} className={wrapperClassName}>
        {children}
      </div>
    </MuiTooltip>
  )
}

export default Tooltip
